/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import LessonProgressUtils from 'edrolo/utils/LessonProgressUtils';
import QuizAttemptUtils from 'edrolo/utils/QuizAttemptUtils';
import chunkGroupClassNames from 'edrolo/utils/chunkGroupClassNames';
import { getCorrectnessMap } from 'edrolo/utils/ExamQuestionUtils';
import studentLessonProgressLoader from './studentLessonProgressLoader';
import QuizAttemptPanel from './QuizAttemptPanel';
import { QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

// TODO move to QuizAttemptUtils
function isSelfMarkQuizAttempt(quizAttempt) {
  return (
    quizAttempt &&
    quizAttempt.get('answer_type') === QUESTION_TYPES.INTEGER &&
    quizAttempt.get('reviewed_question_attempt') !== null
  );
}

// TODO move to QuizAttemptUtils
function isPracticeMarkQuizAttempt(quizAttempt) {
  return (
    quizAttempt &&
    quizAttempt.get('answer_type') === QUESTION_TYPES.INTEGER &&
    quizAttempt.get('reviewed_question_attempt') === null
  );
}

@studentLessonProgressLoader
class StudentQuizProgress extends Component {
  shouldShowChunk(chunk) {
    return (
      chunk.get('question') !== null &&
      !chunk.getIn(['question', 'question_to_review'])
    );
  }

  renderChunk(chunk, classes, selfMarkChunk) {
    const chunkWithMarks = selfMarkChunk || chunk;

    const marks = this.renderMarks(
      chunkWithMarks.get('last_attempt'),
      chunkWithMarks.get('question')
    );

    const correct = QuizAttemptUtils.isCorrect(
      chunkWithMarks.get('last_attempt'),
      chunkWithMarks.get('question')
    );

    classes = classNames(classes, {
      'has-attempt': chunk.get('last_attempt') !== null,
      'is-correct': correct,
    });

    const quiz_attempts = chunkWithMarks.getIn(['question', 'attempts'], []);

    return (
      <li className={classes} key={chunk.get('pk')}>
        <span className="title">
          <a href={chunk.get('url')} target="_blank" rel="noopener noreferrer">
            {chunk.get('title')}
          </a>
        </span>

        {chunk.getIn(['question', 'answer_type']) !== QUESTION_TYPES.FREE_TEXT
          ? quiz_attempts.map((quiz_result) => {
              /* qr is a 2-list [id, is_correct] */
              const qrCx = classNames(getCorrectnessMap(quiz_result.get(1)));
              return (
                <span
                  className={`quiz-result ${qrCx}`}
                  key={quiz_result.get(0)}
                />
              );
            })
          : null}

        <span className="marks">
          {!isPracticeMarkQuizAttempt(chunk.get('last_attempt')) ? marks : '-'}
        </span>
        <div className="note">
          {isPracticeMarkQuizAttempt(chunk.get('last_attempt')) ? (
            <span>Student marked this response: {marks}</span>
          ) : selfMarkChunk ? (
            <QuizAttemptPanel chunk={chunk} marks={marks} />
          ) : null}
        </div>
      </li>
    );
  }

  renderMarks(quizAttempt, question) {
    if (QuizAttemptUtils.isWorthFullMarksOrZero(quizAttempt)) {
      const marks_available = question.get('marks_available');
      const marks_obtained = quizAttempt.get('is_correct')
        ? marks_available
        : 0;
      return `${marks_obtained}/${marks_available}`;
    } else if (
      isSelfMarkQuizAttempt(quizAttempt) ||
      isPracticeMarkQuizAttempt(quizAttempt)
    ) {
      return `${quizAttempt.get('answer')}/${question.get(
        'indicated_maximum_marks'
      )}`;
    } else if (
      question.get('indicated_maximum_marks') &&
      _.isEmpty(quizAttempt)
    ) {
      // If this is an unmarked self-mark question, show -/x
      return `-/${question.get('indicated_maximum_marks')}`;
    }
    return '-';
  }

  render() {
    const progress = this.props.lessonProgress.lessonProgress;
    const studentId = this.props.studentId;
    const lessonId = this.props.lessonId;
    const chunks = progress.getIn([studentId, lessonId]) || [];
    const chunksToShow = chunks.filter(this.shouldShowChunk);

    return (
      <ul className="quiz-progress">
        {chunksToShow.map(function (chunk, i) {
          const nextChunk = chunksToShow.get(i + 1);
          const selfMarkChunk = LessonProgressUtils.findSelfMarkChunk(
            chunk,
            chunks
          );
          const classes = chunkGroupClassNames(chunk, nextChunk, 'chunk');
          return this.renderChunk(chunk, classes, selfMarkChunk);
        }, this)}
      </ul>
    );
  }
}

export default StudentQuizProgress;
